import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { OrderSearchTypeConstants } from 'src/app/core/constants/order-search-type-constants';
import { OrderModel, RequestTemplateDTO, StatusDTO, RequestActDTO, EmployeeDTO, OrdersForNotification } from './model';

export const orderAdapter: EntityAdapter<OrderModel> = createEntityAdapter<OrderModel>({
  selectId: model => model.id,
});

export interface OrderState extends EntityState<OrderModel> {
  isLoading?: boolean;
  error?: any;
  filterType?: string;
  selected: OrderModel;
  selectedEmployeeForId?: number;
  template: RequestTemplateDTO;
  statuses: StatusDTO[];
  acts: RequestActDTO[];
  forNotification: OrdersForNotification[];
  isLoadingForNotification?: boolean;
}

export const initialState: OrderState = orderAdapter.getInitialState({
  isLoading: false,
  error: null,
  filterType: OrderSearchTypeConstants.searchByDate,
  selected: null,
  selectedEmployeeForId: null,
  template: null,
  statuses: null,
  acts: null,
  forNotification: null,
  isLoadingForNotification: false,
});
